import React from 'react';
import Security from '../../utils/Security';

const CurrentEmploymentInfo = ({ children }) => {
  if (Security.isDoubleBlinded()) return null;
  return <>{children}</>;
};

export default CurrentEmploymentInfo;
